import { createContext } from "react";

export const UserContext = createContext({
  email: "",
  name: "",
  profile: "",
  isRolAdmin: false,
  active: false,
});
